import * as React from 'react';
import { Button, CircularProgress, IconButton, Tooltip } from '@mui/material';
import LogoutIcon from '@mui/icons-material/ExitToApp';
import autobind from 'autobind-decorator';
import { RouterStore } from 'mobx-react-router';
import AccountService from '../../service/AccountService';
import { inject, observer } from 'mobx-react';
import { observable } from 'mobx';
import { withStyles } from '@mui/styles';

// const NavButton = withStyles({
//   // label: {
//   //   color: '#FFF',
//   // },
// })(Button);
const MenuNavButton = withStyles({
  colorInherit: {
    color: '#000',
  },
})(Button);

type LogoutButtonProps = {
  routing?: RouterStore;
  account?: AccountService;
  type?: string;
  view?: string;
};

@inject('account')
@inject('routing')
@observer
export default class LogoutButton extends React.Component<LogoutButtonProps> {
  @observable
  private _loading = false;

  @autobind
  async handleLogout() {
    var { account, routing } = this.props;
    this._loading = true;
    await account.handleLogout();
    this._loading = false;

    if (account.user == null) {
      routing.replace('/login');
    }
  }

  render() {
    let { view } = this.props;
    return (
      <React.Fragment>
        {this.props.type === 'MOBILE' || view === 'EDIT' ? (
          <MenuNavButton
            onClick={this.handleLogout}
            disabled={this._loading}
            color='inherit'
          >
            {this._loading ? (
              <CircularProgress size={18} style={{ color: 'white' }} />
            ) : (
              <LogoutIcon style={{ marginRight: '10px' }} />
            )}
            Logout
          </MenuNavButton>
        ) : (
          <Button
            onClick={this.handleLogout}
            disabled={this._loading}
            color='inherit'
          >
            {this._loading ? (
              <CircularProgress size={18} style={{ color: 'white' }} />
            ) : (
              <LogoutIcon style={{ marginRight: '10px' }} />
            )}
            Logout
          </Button>
        )}
      </React.Fragment>
    );
  }
}
